<template>
  <div>
    <a-config-provider :locale="$locale">
      <router-view></router-view>
    </a-config-provider>
  </div>
</template>

<script>

export default {
  name: 'App'
}
</script>

<style lang="less" src="../src/assets/style/global.less"></style>
<style lang="less" src="../src/assets/style/style.less"></style>
